import { render, staticRenderFns } from "./PdvSalesmanSelect.vue?vue&type=template&id=1c5c9745"
import script from "./PdvSalesmanSelect.vue?vue&type=script&lang=js"
export * from "./PdvSalesmanSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports